import Dexie, { Table } from 'dexie'
import type { Order, Customer } from '../types'
import usePwaUpdateStore from './pwaUpdate'

// ─── Types des tables sans type complet connu ─────────────────────────────────

/** Vente RAL (Retail À Livraison) — structure complète à typer lors de la migration des hooks */
export interface VenteRAL {
   id: string
   [key: string]: unknown
}

/** Confié — structure complète à typer lors de la migration des hooks */
export interface Confie {
   id: string
   [key: string]: unknown
}

/** Confié RAL — structure complète à typer lors de la migration des hooks */
export interface ConfieRAL {
   id: string
   [key: string]: unknown
}

// ─── Classe Dexie typée ───────────────────────────────────────────────────────

/**
 * Base de données IndexedDB via Dexie.
 *
 * https://dexie.org/docs/Version/Version.stores() :
 * - Seules les propriétés à indexer doivent être déclarées (pas toutes les colonnes)
 *   ++     Clé primaire auto-incrémentée
 *   &      Index unique
 *   *      Index multi-valeur (si la clé est un tableau)
 *   [A+B]  Index/clé primaire composite
 *
 * Seuls string, number, Date et Array sont indexables.
 * boolean, null et undefined ne le sont pas.
 */
class SalesDatabase extends Dexie {
   bi_orders!: Table<Order, string>
   orders!: Table<Order, string>
   customers!: Table<Customer, string>
   ventes_ral!: Table<VenteRAL, string>
   confies!: Table<Confie, string>
   confies_ral!: Table<ConfieRAL, string>

   constructor() {
      super('sales')
      this.version(18).stores({
         bi_orders:   '&id, customer_id, status, date',
         // orders: '[short_udid+id], id, customer_id, status, date',
         orders:      '&id, customer_id, status, date',
         customers:   '&id',
         ventes_ral:  '&id',
         confies:     '&id',
         confies_ral: '&id',
      })
      this.version(19).stores({
         bi_orders:   '&id, customer_id, status, date, type',
         orders:      '&id, customer_id, status, date, type',
         customers:   '&id',
         ventes_ral:  '&id',
         confies:     '&id',
         confies_ral: '&id',
      })
      this.version(20).stores({
         bi_orders:   '&id, customer_id, status, date, type',
         orders:      '&id, customer_id, status, date, type, origin_id',
         customers:   '&id',
         ventes_ral:  '&id',
         confies:     '&id',
         confies_ral: '&id',
      })
   }
}

export const db = new SalesDatabase()

// messika-pwa#34 : base locale plus récente que ce build (retour vers un canal dont le schéma est plus ancien).
// On ne purge RIEN : l'app affiche un message bloquant (PwaUpdateLayer).
db.open().catch((e) => {
   if (e?.name === 'VersionError') {
      console.error('Dexie VersionError : base locale plus récente que ce build', e)
      usePwaUpdateStore.setState({ dbIncompatible: true })
   }
})
